import styled from 'styled-components';

export const Main = styled.div`
  position: absolute;
  display: flex;
  width: 100vw;
  height: 100vh;
  z-index: 3;
`;

export const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-color: ${({ theme }) => theme.neutral_700};
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  canvas {
    width: 200px;
    border-radius: 5px;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      text-decoration: underline;
    }
  }
`;
